export const UPDATE_USER_DATA = "UPDATE_USER_DATA";

export const UPDATE_ADD_ADDRESS_POPUP_STATE = "UPDATE_ADD_ADDRESS_POPUP_STATE";
export const UPDATE_ADD_PRODUCT_POPUP_STATE = "UPDATE_ADD_PRODUCT_POPUP_STATE";
export const UPDATE_PAYMENT_POPUP_STATE = "UPDATE_PAYMENT_POPUP_STATE";
